export const getFontFiles = (allFonts: { file: string }[]) =>
  allFonts.map(({ file }) => file)
